import actions from "./actions";

const initState = {
    label: null,
    objects: null,
    annotation: null,
    readAnnotationState: null,
    updateAnnotationState: null,
    deleteAnnotationState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.SET_ANNOTATION:
            return {
                ...state,
                annotation: action.annotation,
            };
        case actions.SET_ANNOTATION_LABEL:
            return {
                ...state,
                label: action.label,
            };
        case actions.SET_ANNOTATION_OBJECTS:
            return {
                ...state,
                objects: action.objects,
            };
        case actions.READ_ANNOTATION_REQUEST:
            return {
                ...state,
                readAnnotationState: 'request',
            };
        case actions.READ_ANNOTATION_SUCCESS:
            return {
                ...state,
                readAnnotationState: 'success',
                annotation: action.annotation,
                objects: action.annotation?.objects,
            };
        case actions.UPDATE_ANNOTATION_REQUEST:
            return {
                ...state,
                updateAnnotationState: 'request',
            };
        case actions.UPDATE_ANNOTATION_SUCCESS:
            return {
                ...state,
                updateAnnotationState: 'success',
            };
        case actions.DELETE_ANNOTATION_REQUEST:
            return {
                ...state,
                deleteAnnotationState: 'request',
            };
        case actions.DELETE_ANNOTATION_SUCCESS:
            return {
                ...state,
                deleteAnnotationState: 'success',
            };
        case actions.ANNOTATION_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
